import DOMPurify from 'dompurify';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { notification } from 'ui';

const Icon = styled.i`
  color: rgb(0, 152, 204);
  cursor: pointer;
  margin-left: 5px;
  margin-top: 2px;
`;

const Wrapper = styled.div`
  width: 100%;
  max-width: ${p => p.prefixWidth ? `calc(100% - ${p.prefixWidth})` : '100%'};
  display: flex;
  span {
    max-width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const ClipboardCopy = ({
  children,
  onlyCopyThroughIcon = false,
  prefixWidth,
}) => {
  const intl = useIntl();
  let textToCopy = children;

  if (typeof children === 'object') {
    textToCopy = children?.props?.children;
  }

  const handleClick = () => {
    navigator?.clipboard?.writeText(DOMPurify.sanitize(textToCopy));
    notification.info({
      message: intl.formatMessage({ id: 'common.COPIED_TO_CLIPBOARD' }),
      key: 'copySuccess',
      className: 'extended-notification',
      duration: 3,
      placement: 'top',
    });
  };

  if (textToCopy) {
    return <Wrapper prefixWidth={prefixWidth}>
      <span onClick={() => !onlyCopyThroughIcon && handleClick()}>{children}</span>
      <Icon onClick={handleClick} className='fa-solid fa-copy' />
    </Wrapper>;
  }
  return children || null;
};

ClipboardCopy.propTypes = {
  children: PropTypes.node,
  onlyCopyThroughIcon: PropTypes.bool,
  prefixWidth: PropTypes.string,
};

export default ClipboardCopy;
